module.exports = __webpack_public_path__ + "img/vk_hover.ef751fae.png";